import { SingleInvoiceLineItem } from '..';
import { fToCurrency } from '@web/utils/src';

interface SingleDeliveryItemProps {
  item: SingleInvoiceLineItem;
}

const SingleDeliveryItem: React.FC<SingleDeliveryItemProps> = (props) => {
  const { item } = props;

  return (
    <div key={item.id} className="flex text-1-2 p-1-0">
      <div className="w-[10%]">
        <span className="font-bd">
          {item.lineTotalQuantity} {item.itemUnit}
        </span>
      </div>
      <div className="w-full">
        <span>{item.name}</span>
      </div>
      <div className="w-[10%]">
        <span className="font-bd">{fToCurrency(item.lineTotalNet ?? 0)}</span>
      </div>
    </div>
  );
};

export default SingleDeliveryItem;
